var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-cart",
      class: {
        "sidebar-cart--inline": _vm.isInline,
        "sidebar-cart--editable": _vm.isEditable,
      },
    },
    [
      _c("div", { staticClass: "sidebar-cart__wrapper" }, [
        _c(
          "div",
          { staticClass: "sidebar-cart__cross-sell" },
          [_vm.isEditable && !_vm.isInline ? _c("CartCrossSell") : _vm._e()],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sidebar-cart__cart" },
          [
            _c("div", { staticClass: "sidebar-cart__inner" }, [
              _c("h2", { staticClass: "sidebar-cart__title" }, [
                _c("span", {
                  staticClass: "sidebar-cart__title-text",
                  domProps: { innerHTML: _vm._s(_vm.$t("cart.title")) },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sidebar-cart__title-close",
                    on: { click: _vm.close },
                  },
                  [_c("SVGClose")],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.showContinue
                ? _c(
                    "div",
                    { staticClass: "sidebar-cart__continue" },
                    [
                      _c("Button", {
                        staticClass: "sidebar-cart__continue-button",
                        attrs: {
                          text: _vm.$t("cart.continueShopping"),
                          level: "tertiary",
                          type: "button",
                          arrow: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.backToShop.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.totalItemsWithoutAdditional > 0 && !_vm.isCartValidForCheckout
                ? _c("div", {
                    staticClass: "sidebar-cart__warning",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cart.warningMinimumAmount", {
                          price: _vm.$options.filters.madpricecent(
                            _vm.minCartPrice,
                            "html"
                          ),
                        })
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "sidebar-cart__list" },
                [
                  _vm._l(_vm.items, function (item) {
                    return _c(_vm.itemType(item), {
                      key: item.id,
                      tag: "component",
                      attrs: { item: item, locked: _vm.lockedItems[item.id] },
                      on: {
                        sub: function ($event) {
                          return _vm.onSub(item)
                        },
                        add: function ($event) {
                          return _vm.onAdd(item)
                        },
                        edit: function ($event) {
                          return _vm.onChildProductModal(item)
                        },
                        remove: function ($event) {
                          return _vm.onDelete(item)
                        },
                        copy: function ($event) {
                          return _vm.onCopy(item)
                        },
                      },
                    })
                  }),
                  _vm._v(" "),
                  _vm.totalItemsWithoutAdditional <= 0
                    ? _c("li", {
                        staticClass:
                          "sidebar-cart__list-item sidebar-cart__list-item--empty",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("cart.warningCartEmpty")),
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.cartCrossSell.length && _vm.isEditable
              ? _c(
                  "div",
                  { staticClass: "sidebar-cart__cross-sell-mobile" },
                  [
                    _c("Button", {
                      staticClass: "sidebar-cart__cross-sell-mobile-button",
                      attrs: {
                        level: "tertiary",
                        type: "button",
                        text: _vm.$t("cart.crossSell.button"),
                        arrow: "",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onCrossSellOpen.apply(null, arguments)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "sidebar-cart__cross-sell-mobile-hint",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cart.crossSell.buttonHint")),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasFeature("FEATURE_ADDITIONALPRODUCTS") &&
            _vm.additionalItemsAvailable &&
            _vm.totalItemsWithoutAdditional
              ? _c("SidebarCartAdditionalProducts", {
                  attrs: {
                    "additional-items": _vm.additionalItems,
                    "additional-items-price": _vm.additionalItemsPrice,
                    "additional-open": _vm.additionalOpen,
                  },
                  on: {
                    toggle: _vm.onAdditionalToggle,
                    edit: _vm.onAdditionalEdit,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.totalItemsWithoutAdditional
              ? _c(
                  "div",
                  { staticClass: "sidebar-cart__summary" },
                  [
                    _vm._l(_vm.discounts, function (discount) {
                      return _c(
                        "div",
                        {
                          key: discount.name,
                          staticClass: "sidebar-cart__summary-row",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sidebar-cart__summary-row-info" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sidebar-cart__summary-row-info-title",
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(discount.name),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          discount.removable !== false
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "sidebar-cart__summary-row-remove",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$store.dispatch(
                                        "cart/removeCoupon"
                                      )
                                    },
                                  },
                                },
                                [_c("SVGClose")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "sidebar-cart__summary-row-price",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.madpricecent(
                                  discount.amount.current,
                                  "short"
                                )
                              ),
                            },
                          }),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.subtotal < _vm.total
                      ? _c(
                          "div",
                          { staticClass: "sidebar-cart__summary-subtotal" },
                          [
                            _c("div", {
                              staticClass:
                                "sidebar-cart__summary-subtotal-title",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("cart.subtotal")),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "sidebar-cart__summary-subtotal-price",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.madpricecent(
                                    _vm.subtotal,
                                    "short"
                                  )
                                ),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showDeliveryPrice
                      ? _c(
                          "div",
                          { staticClass: "sidebar-cart__summary-row" },
                          [
                            _c(
                              "div",
                              { staticClass: "sidebar-cart__summary-row-info" },
                              [
                                _c("div", {
                                  staticClass:
                                    "sidebar-cart__summary-row-info-title",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("cart.deliveryFee")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.minCartFreePrice > 0 &&
                                _vm.deliveryPrice > 0 &&
                                _vm.minCartFreePrice -
                                  _vm.subtotalBeforePromotion >
                                  0
                                  ? _c("div", {
                                      staticClass:
                                        "sidebar-cart__summary-row-info-meta",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "cart.freeDeliveryDifference",
                                            {
                                              amount:
                                                _vm.$options.filters.madpricecent(
                                                  _vm.minCartFreePrice -
                                                    _vm.subtotalBeforePromotion
                                                ),
                                            }
                                          )
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.deliveryPrice
                              ? _c("div", {
                                  staticClass:
                                    "sidebar-cart__summary-row-price",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$options.filters.madpricecent(
                                        _vm.deliveryPrice,
                                        "short"
                                      )
                                    ),
                                  },
                                })
                              : _c("div", {
                                  staticClass: "sidebar-cart__summary-row-meta",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("cart.deliveryFeeFree")
                                    ),
                                  },
                                }),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "sidebar-cart__summary-row" },
                          [
                            _c(
                              "div",
                              { staticClass: "sidebar-cart__summary-row-info" },
                              [
                                _c("div", {
                                  staticClass:
                                    "sidebar-cart__summary-row-info-title",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("cart.deliveryFee")
                                    ),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sidebar-cart__summary-row-meta",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("cart.deliveryFeeLater")
                                ),
                              },
                            }),
                          ]
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "sidebar-cart__summary-total" }, [
                      _c("div", {
                        staticClass: "sidebar-cart__summary-total-title",
                        domProps: { innerHTML: _vm._s(_vm.$t("cart.total")) },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "sidebar-cart__summary-total-price",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$options.filters.madpricecent(
                              _vm.total,
                              "short"
                            )
                          ),
                        },
                      }),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar-cart__button" },
              [
                _c("Button", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.totalItemsWithoutAdditional > 0,
                      expression: "totalItemsWithoutAdditional > 0",
                    },
                  ],
                  staticClass: "sidebar-cart__submit",
                  attrs: {
                    disabled: !_vm.isCartValidForCheckout,
                    text: _vm.$t("cart.orderButton"),
                    level: "primary",
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.gotoCheckout.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_ADDITIONALPRODUCTS")
        ? _c(
            "Modal",
            {
              ref: "modal",
              attrs: {
                "overlay-type": "additional-products",
                "html-classes": ["hide--header", "show--modal"],
                "soft-close": "",
              },
              on: {
                close: _vm.onModalClose,
                softclose: _vm.onAdditionalEditSoftClose,
              },
            },
            [
              _c("OverlayAdditionalProducts", {
                ref: "overlayAdditionalProducts",
                on: { close: _vm.onAdditionalEditClose },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "chartChangeModal",
          attrs: {
            "overlay-type": "cart-change",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
          },
          on: { close: _vm.onModalClose },
        },
        [
          _c("OverlayCartChange", {
            attrs: {
              title: _vm.$t("cart.timeEdit.cartChange.title"),
              message: _vm.$t("cart.timeEdit.cartChange.textAutomatic"),
              "changed-items": _vm.cartChangedItems,
            },
            on: { confirm: _vm.onCartChangeClose },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.cartCrossSell.length && _vm.isEditable
        ? _c(
            "Modal",
            {
              ref: "crossSellModal",
              attrs: {
                "overlay-type": "cross-sell",
                "html-classes": ["hide--header", "show--modal"],
              },
              on: { close: _vm.onModalClose },
            },
            [
              _c("CartCrossSell"),
              _vm._v(" "),
              _c("Button", {
                staticClass: "sidebar-cart__cross-sell-mobile-close",
                attrs: {
                  text: _vm.$t("cart.crossSell.closeButton"),
                  level: "primary",
                  type: "button",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onCrossSellClose.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }